import { prefixerI } from '.'

export const ROUTE_INFORME_CCONT_PROVEEDOR_ESTAB = prefixerI('cont-rpov')
